export const clean = (v) => {
  const s = (v ?? "").toString().trim();
  if (!s) return "";
  const low = s.toLowerCase();
  return low === "null" || low === "undefined" ? "" : s;
};

export const has = (v) => clean(v) !== "";
